var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisitVideo = function SvgVisitVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.647 11.268 3.308-2.48a.351.351 0 0 0 0-.566l-3.308-2.48a.354.354 0 0 0-.566.284v4.958c0 .29.333.46.566.284zm.85-9.846a7.086 7.086 0 0 0-7.083 7.083 7.086 7.086 0 0 0 7.083 7.083 7.086 7.086 0 0 0 7.084-7.083 7.086 7.086 0 0 0-7.084-7.083zm0 12.75a5.674 5.674 0 0 1-5.666-5.667A5.674 5.674 0 0 1 8.497 2.84a5.674 5.674 0 0 1 5.667 5.666 5.674 5.674 0 0 1-5.667 5.667z",
    fill: "#58B847"
  })));
};
export default SvgVisitVideo;